import { render, staticRenderFns } from "./pane-person-info.vue?vue&type=template&id=d07a5b58"
import script from "./pane-person-info.vue?vue&type=script&lang=js"
export * from "./pane-person-info.vue?vue&type=script&lang=js"
import style0 from "./pane-person-info.vue?vue&type=style&index=0&id=d07a5b58&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports